import React from "react";
import { Box, Typography } from "@mui/material";
import { useKivunovaTranslation } from "@kivunova/kivufrontendcommon";
import { Product } from "./types/products";
import {
  getProductDetailFields,
  PRODUCT_DETAIL_FIELD_LABEL_FALLBACKS,
  isUserIdField
} from "./utils/productUtils";
import { UserName } from "../common/UserName/UserName";
import DetailFieldGrid from "../common/DetailFieldGrid/DetailFieldGrid";

interface ProductDetailsTabProps {
  product: Product;
}

const ProductDetailsTab: React.FC<ProductDetailsTabProps> = ({ product }) => {
  const { t } = useKivunovaTranslation();
  const fields = getProductDetailFields(product);

  const rows = fields.map(([labelKey, value]) => ({
    label: t(
      labelKey,
      PRODUCT_DETAIL_FIELD_LABEL_FALLBACKS[labelKey] ?? labelKey
    ),
    value: isUserIdField(labelKey) ? (
      <UserName userId={String(value ?? "")} />
    ) : (
      (value ?? "-")
    )
  }));

  return (
    <Box>
      <Typography
        variant="subtitle2"
        fontWeight={700}
        color="text.secondary"
        sx={{ mb: 1.5, fontSize: "0.8125rem", letterSpacing: "0.04em" }}
      >
        {t("product-details-section-title", "PRODUCT INFORMATION")}
      </Typography>
      <DetailFieldGrid rows={rows} data-testid="product-details-grid" />
    </Box>
  );
};

export default ProductDetailsTab;
